import type { MemberWithRatings } from "../../types";
import { isSyntheticMember, type MemberFilter } from "./memberFilter";

interface MembersFilterBarProps {
  members: readonly MemberWithRatings[];
  value: MemberFilter;
  onChange: (value: MemberFilter) => void;
  children?: never;
}

const BASE = "min-h-[32px] rounded-full border px-3 text-xs font-medium transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand-green-50";
const ACTIVE = "border-brand-green bg-brand-green-10 text-brand-green";
const INACTIVE = "border-gray-300 bg-white text-gray-600 hover:bg-gray-50";

/** Quick filter above the members grid: every member, or only the Spock cohorts and Gradient Doe. */
export function MembersFilterBar({ members, value, onChange }: MembersFilterBarProps) {
  const syntheticCount = members.filter(isSyntheticMember).length;
  const options: readonly { value: MemberFilter; label: string }[] = [
    { value: "all", label: `All members (${members.length})` },
    { value: "synthetic", label: `Spock & Gradient Doe (${syntheticCount})` },
  ];

  return (
    <div className="mb-2 flex items-center justify-end gap-2" role="group" aria-label="Filter members">
      <span className="text-xs text-gray-500">Show</span>
      {options.map((option) => (
        <button key={option.value} type="button" aria-pressed={value === option.value} className={`${BASE} ${value === option.value ? ACTIVE : INACTIVE}`} onClick={() => onChange(option.value)}>
          {option.label}
        </button>
      ))}
    </div>
  );
}
